/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Content_BooksInputs */

const en_onboarding_content_books = /** @type {(inputs: Onboarding_Content_BooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Books (fiction or non-fiction)`)
};

const es_onboarding_content_books = /** @type {(inputs: Onboarding_Content_BooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libros (ficción o no ficción)`)
};

/**
* | output |
* | --- |
* | "Books (fiction or non-fiction)" |
*
* @param {Onboarding_Content_BooksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_content_books = /** @type {((inputs?: Onboarding_Content_BooksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Content_BooksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_content_books(inputs)
	return en_onboarding_content_books(inputs)
});